import React from 'react';
import './reports.css';
import "../index";
import { 
  FileCheck, 
  ShieldCheck, 
  ShieldAlert,
  CheckCircle2, 
  FileText, 
  Cpu, 
  TrendingUp, 
  Eye, 
  Download, 
  Share2, 
  MoreHorizontal, 
  Info,
  Shield,
  Layers,
  Box,
  Library,
  Network,
  Bell
} from 'lucide-react';

const W = 500, H = 150, padL = 10, padR = 10, padT = 10, padB = 10;
const maxVal = 1000;

const chartData = [
  { label: 'May 20', signed: 400, verified: 300, artifact: 150 },
  { label: 'May 25', signed: 650, verified: 500, artifact: 200 },
  { label: 'May 30', signed: 500, verified: 420, artifact: 180 },
  { label: 'Jun 4',  signed: 780, verified: 620, artifact: 260 },
  { label: 'Jun 9',  signed: 600, verified: 530, artifact: 220 },
  { label: 'Jun 14', signed: 850, verified: 700, artifact: 300 },
  { label: 'Jun 19', signed: 950, verified: 800, artifact: 350 },
];

const toX = (i) => padL + (i / (chartData.length - 1)) * (W - padL - padR);
const toY = (v) => padT + (1 - v / maxVal) * (H - padT - padB);

const buildPath = (key) =>
  chartData.map((d, i) => `${i === 0 ? 'M' : 'L'}${toX(i)},${toY(d[key])}`).join(' ');

const lines = [
  { key: 'signed',   color: '#8b5cf6' },
  { key: 'verified', color: '#3b82f6' },
  { key: 'artifact', color: '#10b981' },
];

const ReportDashboard = () => {
  // Mock data for the Recent Reports table
  const reports = [
    { name: 'Monthly Audit Report – May 2026', type: 'Audit Report', date: 'Jun 19, 2026 10:30 AM', status: 'Ready', color: '#ef4444' },
    { name: 'Trust Assessment Report – Q2 2026', type: 'Trust Report', date: 'Jun 19, 2026 09:15 AM', status: 'Ready', color: '#3b82f6' },
    { name: 'PQ Adoption & Readiness Report', type: 'Compliance Report', date: 'Jun 18, 2026 04:45 PM', status: 'Ready', color: '#10b981' },
    { name: 'Verification Activity Report', type: 'Verification Report', date: 'Jun 18, 2026 02:30 PM', status: 'Ready', color: '#8b5cf6' },
    { name: 'Artifact Signing Report', type: 'Artifact Report', date: 'Jun 17, 2026 11:20 AM', status: 'Ready', color: '#a855f7' },
  ];

  return (
    <div className="reports-page">
    <div className="reports-dashboard-container">
      {/* Top Metrics Row */}
      <header className="reports-metrics-grid">
        <div className="reports-metric-card">
          <div className="reports-metric-header">
            <div className="reports-icon-wrapper reports-purple"><FileCheck size={20} /></div>
            <div className="reports-metric-meta">
              <span className="reports-metric-label">Signed Documents</span>
              <h2 className="reports-metric-value">12,480</h2>
            </div>
          </div>
          <div className="reports-metric-footer reports-positive">
            <TrendingUp size={10} /> <span>18%</span> <span className="reports-text-muted">vs Apr 20 – May 19</span>
          </div>
        </div>

        <div className="reports-metric-card">
          <div className="reports-metric-header">
            <div className="reports-icon-wrapper reports-blue"><ShieldCheck size={20} /></div>
            <div className="reports-metric-meta">
              <span className="reports-metric-label">Verified Documents</span>
              <h2 className="reports-metric-value">10,240</h2>
            </div>
          </div>
          <div className="reports-metric-footer reports-positive">
            <TrendingUp size={10} /> <span>25%</span> <span className="reports-text-muted">vs Apr 20 – May 19</span>
          </div>
        </div>

        <div className="reports-metric-card">
          <div className="reports-metric-header">
            <div className="reports-icon-wrapper reports-green"><CheckCircle2 size={20} /></div>
            <div className="reports-metric-meta">
              <span className="reports-metric-label">Trust Score</span>
              <h2 className="reports-metric-value">96 <span className="reports-total-scale">/ 100</span></h2>
              <span className="reports-status-badge-text reports-green-text">Very Strong</span>
            </div>
          </div>
          <div className="reports-metric-footer reports-positive">
            <TrendingUp size={10} /> <span>5pts</span> <span className="reports-text-muted">vs Apr 20 – May 19</span>
          </div>
        </div>

        <div className="reports-metric-card">
          <div className="reports-metric-header">
            <div className="reports-icon-wrapper reports-orange"><ShieldAlert size={20} /></div>
            <div className="reports-metric-meta">
              <span className="reports-metric-label">Compliance Rate</span>
              <h2 className="reports-metric-value">99.2%</h2>
              <span className="reports-status-badge-text reports-orange-text">Passed</span>
            </div>
          </div>
          <div className="reports-metric-footer reports-positive">
            <TrendingUp size={9} /> <span>2.1%</span> <span className="reports-text-muted">vs Apr 20 – May 19</span>
          </div>
        </div>

        <div className="reports-metric-card">
          <div className="reports-metric-header">
            <div className="reports-icon-wrapper reports-pink"><FileText size={20} /></div>
            <div className="reports-metric-meta">
              <span className="reports-metric-label">Audit Events</span>
              <h2 className="reports-metric-value">1,842</h2>
            </div>
          </div>
          <div className="reports-metric-footer reports-positive">
            <TrendingUp size={12} /> <span>12%</span> <span className="reports-text-muted">vs Apr 20 – May 19</span>
          </div>
        </div>

        <div className="reports-metric-card">
          <div className="reports-metric-header">
            <div className="reports-icon-wrapper reports-deep-purple"><Cpu size={20} /></div>
            <div className="reports-metric-meta">
              <span className="reports-metric-label">PQ Adoption</span>
              <h2 className="reports-metric-value">68%</h2>
            </div>
          </div>
          <div className="reports-metric-footer reports-positive">
            <TrendingUp size={12} /> <span>14%</span> <span className="reports-text-muted">vs Apr 20 – May 19</span>
          </div>
        </div>
      </header>

      {/* Main Grid Section */}
      <div className="reports-main-dashboard-layout" style={{ marginTop: '10px' }}>
        
        {/* Left Column blocks */}
        <div className="reports-left-column">
          
          {/* Charts Sub-grid */}
          <div className="reports-charts-grid">
            {/* Trust Activity Line Chart Placeholder */}
            <div className="reports-card reports-chart-card">
              <div className="reports-card-header">
                <div className="reports-title-with-info">
                  <h3>Trust Activity Over Time</h3>
                  <Info size={14} className="reports-info-icon" />
                </div>
                <select className="reports-dropdown-select" defaultValue="Daily">
                  <option>Daily</option>
                  <option>Weekly</option>
                  <option>Monthly</option>
                </select>
              </div>

              <div className="reports-chart-legend">
                <span className="reports-legend-item"><span className="reports-dot reports-purple-dot"></span> Documents Signed</span>
                <span className="reports-legend-item"><span className="reports-dot reports-blue-dot"></span> Documents Verified</span>
                <span className="reports-legend-item"><span className="reports-dot reports-green-dot"></span> Artifacts Signed</span>
              </div>

              <div className="reports-mock-line-chart">
                <svg viewBox={`0 0 ${W} ${H}`} className="reports-chart-svg" style={{ overflow: 'visible' }}>
                {/* Horizontal grid lines */}
                {[0, 200, 400, 600, 800, 1000].map((v) => (
                  <line key={v} x1={padL} x2={W - padR} y1={toY(v)} y2={toY(v)}
                    stroke="#f1f5f9" strokeWidth="1" />
                ))}
                {/* Y-axis labels */}
                {[0, 200, 400, 600, 800, 1000].map((v) => (
                  <text key={v} x={padL - 4} y={toY(v) + 3} textAnchor="end"
                    fontSize="9" fill="#94a3b8">{v === 1000 ? '1K' : v}</text>
                ))}
                {/* Lines */}
                {lines.map(({ key, color }) => (
                  <path key={key} d={buildPath(key)} fill="none" stroke={color} strokeWidth="2" />
                ))}
                {/* Dots */}
                {lines.map(({ key, color }) =>
                  chartData.map((d, i) => (
                    <circle key={`${key}-${d.label}`} cx={toX(i)} cy={toY(d[key])} r="3"
                      fill="#fff" stroke={color} strokeWidth="2" />
                  ))
                )}
                {/* X-axis labels */}
                {chartData.map((d, i) => (
                  <text key={d.label} x={toX(i)} y={H + 14} textAnchor="middle"
                    fontSize="9" fill="#94a3b8">{d.label}</text>
                ))}
              </svg>
              </div>
            </div>

            {/* Signing by Trust Type Donut Chart */}
            <div className="reports-card reports-chart-card">
              <div className="reports-card-header">
                <div className="reports-title-with-info">
                  <h3>Signing by Trust Type</h3>
                  <Info size={14} className="reports-info-icon" />
                </div>
              </div>
              <div className="reports-donut-chart-container">
                <div className="reports-mock-donut">
                  <div className="reports-donut-hole"></div>
                </div>
                <div className="reports-donut-legend">
                  <div className="reports-legend-row">
                    <span className="reports-legend-label-group"><span className="reports-dot reports-purple-dot"></span> Post-Quantum (PQ)</span>
                    <span className="reports-legend-percentage">68%</span>
                    <span className="reports-legend-count reports-text-muted">8,474</span>
                  </div>
                  <div className="reports-legend-row">
                    <span className="reports-legend-label-group"><span className="reports-dot reports-blue-dot"></span> Hybrid (PQ + Classical)</span>
                    <span className="reports-legend-percentage">24%</span>
                    <span className="reports-legend-count reports-text-muted">2,986</span>
                  </div>
                  <div className="reports-legend-row">
                    <span className="reports-legend-label-group"><span className="reports-dot reports-green-dot"></span> Classical Only</span>
                    <span className="reports-legend-percentage">8%</span>
                    <span className="reports-legend-count reports-text-muted">1,020</span>
                  </div>
                  <hr className="reports-divider" />
                  <div className="reports-legend-row reports-total-row">
                    <span>Total</span>
                    <span></span>
                    <strong>12,480</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Recent Reports Table */}
          <div className="reports-card reports-rtable-card">
            <div className="reports-card-header">
              <h3>Recent Reports</h3>
            </div>
            <div className="reports-rtable-wrapper">
              <table className="reports-table">
                <thead>
                  <tr>
                    <th>REPORT NAME</th>
                    <th>TYPE</th>
                    <th>DATE GENERATED</th>
                    <th>STATUS</th>
                    <th className="text-center">ACTIONS</th>
                  </tr>
                </thead>
                <tbody>
                  {reports.map((report) => (
                    <tr key={report.name}>
                      <td className="reports-report-name-cell">
                        <div className="reports-report-name-inner">
                          <FileText size={16} style={{ color: report.color, flexShrink: 0 }} />
                          <span>{report.name}</span>
                        </div>
                      </td>
                      <td>{report.type}</td>
                      <td className="reports-text-muted">{report.date}</td>
                      <td><span className="reports-status-badge reports-success-bg">{report.status}</span></td>
                      <td className="reports-actions-cell">
                        <div>
                          <div className="reports-actions-card"><button className="reports-action-btn"><Eye size={16} /></button></div>
                          <div className="reports-actions-card"><button className="reports-action-btn"><Download size={16} /></button></div>
                          <div className="reports-actions-card"><button className="reports-action-btn"><Share2 size={16} /></button></div>
                          <div className="reports-actions-card"><button className="reports-action-btn"><MoreHorizontal size={16} /></button></div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="reports-card-footer-link">
              <a href="#all-reports">View All Reports &rarr;</a>
            </div>
          </div>

          {/* Compliance & Standards */}
          <div className="reports-card reports-split-card">
            <div className="reports-card-header">
              <div className="reports-title-with-info">
                <h3>Compliance & Standards</h3>
                <Info size={14} className="reports-info-icon" />
              </div>
            </div>
            <div className="reports-compliance-badges">
              <div className="reports-compliance-item">
                <span className="reports-comp-title">NIST PQC</span>
                <span className="reports-comp-subtitle reports-text-muted">Readiness</span>
                <span className="reports-status-pill reports-compliant"><CheckCircle2 size={12} /> Compliant</span>
              </div>
              <div className="reports-compliance-item">
                <span className="reports-comp-title">ISO 27001</span>
                <span className="reports-comp-subtitle reports-text-muted">Information Security</span>
                <span className="reports-status-pill reports-compliant"><CheckCircle2 size={12} /> Compliant</span>
              </div>
              <div className="reports-compliance-item">
                <span className="reports-comp-title">SOC 2 Type II</span>
                <span className="reports-comp-subtitle reports-text-muted">Security Controls</span>
                <span className="reports-status-pill reports-compliant"><CheckCircle2 size={12} /> Compliant</span>
              </div>
              <div className="reports-compliance-item">
                <span className="reports-comp-title">GDPR</span>
                <span className="reports-comp-subtitle reports-text-muted">Data Protection</span>
                <span className="reports-status-pill reports-compliant"><CheckCircle2 size={12} /> Compliant</span>
              </div>
              <div className="reports-compliance-item">
                <span className="reports-comp-title">DPDPA</span>
                <span className="reports-comp-subtitle reports-text-muted">India Compliance</span>
                <span className="reports-status-pill reports-compliant"><CheckCircle2 size={12} /> Compliant</span>
              </div>
            </div>
            <div className="reports-card-footer-link">
              <a href="#compliance">View Compliance Center &rarr;</a>
            </div>
          </div>

        </div>

        {/* Right Column blocks */}
        <div className="reports-right-column">
          
          {/* Tamper & Risk Overview */}
          <div className="reports-card risk-card">
            <div className="reports-card-header">
              <div className="reports-title-with-info">
                <h3>Tamper & Risk Overview</h3>
                <Info size={14} className="reports-info-icon" />
              </div>
            </div>
            
            <div className="reports-tamper-alert-box">
              <div>
                <span className="reports-alert-title reports-text-muted">Tamper Attempts Detected</span>
                <h2 className="reports-alert-count reports-text-dark">42</h2>
              </div>
              <div className="reports-shield-danger-icon"><ShieldCheck size={28} /></div>
            </div>

            <div className="reports-risk-sub-stats">
              <div className="reports-sub-stat-box reports-blocked">
                <span className="reports-text-muted">Blocked</span>
                <h3>38</h3>
              </div>
              <div className="reports-sub-stat-box reports-review">
                <span className="reports-text-muted">Under Review</span>
                <h3>4</h3>
              </div>
            </div>

            <div className="reports-risk-categories-section">
              <h4>Top Risk Categories</h4>
              <div className="reports-risk-bar-row">
                <span className="reports-text-muted">Expired Certificates</span>
                <div className="reports-bar-wrapper"><div className="reports-bar-fill" style={{ width: '85%' }}></div></div>
                <span className="reports-risk-count">18</span>
              </div>
              <div className="reports-risk-bar-row">
                <span className="reports-text-muted">Unsigned Artifacts</span>
                <div className="reports-bar-wrapper"><div className="reports-bar-fill" style={{ width: '50%' }}></div></div>
                <span className="reports-risk-count">9</span>
              </div>
              <div className="reports-risk-bar-row">
                <span className="reports-text-muted">Weak Algorithms</span>
                <div className="reports-bar-wrapper"><div className="reports-bar-fill" style={{ width: '40%' }}></div></div>
                <span className="reports-risk-count">7</span>
              </div>
              <div className="reports-risk-bar-row">
                <span className="reports-text-muted">Other Risks</span>
                <div className="reports-bar-wrapper"><div className="reports-bar-fill" style={{ width: '15%' }}></div></div>
                <span className="reports-risk-count">2</span>
              </div>
            </div>

            <div className="reports-card-footer-link reports-left-align">
              <a href="#full-risk">View Full Risk Report &rarr;</a>
            </div>
          </div>

          {/* AI Insights Card */}
          <div className="reports-card reports-insights-card">
            <div className="reports-card-header">
              <div className="reports-title-with-info">
                <h3>AI Insights</h3>
                <Info size={14} className="reports-info-icon" />
              </div>
            </div>
            <div className="reports-insights-list">
              <div className="reports-insight-item">
                <div className="reports-insight-icon reports-purple-bg"><TrendingUp size={14} /></div>
                <p><strong>PQ adoption</strong> increased by <strong>18%</strong> compared to last month.</p>
              </div>
              <div className="reports-insight-item">
                <div className="reports-insight-icon reports-blue-bg"><Bell size={14} /></div>
                <p><strong>3 certificates</strong> will expire within the next <strong>30 days</strong>.</p>
              </div>
              <div className="reports-insight-item">
                <div className="reports-insight-icon reports-purple-bg"><FileText size={14} /></div>
                <p><strong>2 unsigned</strong> software artifacts detected in Secure Drive.</p>
              </div>
              <div className="reports-insight-item">
                <div className="reports-insight-icon reports-blue-bg"><CheckCircle2 size={14} /></div>
                <p>Trust score improved from <strong>91 to 96</strong> this month.</p>
              </div>
              <div className="reports-insight-item">
                <div className="reports-insight-icon reports-purple-bg"><Shield size={14} /></div>
                <p>Compliance rate is excellent. Keep up the good work!</p>
              </div>
            </div>
            <div className="reports-card-footer-link reports-left-align">
              <a href="#all-insights">View All Insights &rarr;</a>
            </div>
          </div>

          {/* Artifact Signing Overview */}
          <div className="reports-card">
            <div className="reports-card-header">
              <div className="reports-title-with-info">
                <h3>Artifact Signing Overview</h3>
                <Info size={14} className="reports-info-icon" />
              </div>
            </div>
            <div className="reports-artifacts-grid">
              <div className="reports-artifact-stat">
                <div className="reports-artifact-icon"><Layers size={18} /></div>
                <h4>2,418</h4>
                <span className="reports-text-muted">Containers</span>
              </div>
              <div className="reports-artifact-stat">
                <div className="reports-artifact-icon"><Box size={18} /></div>
                <h4>1,208</h4>
                <span className="reports-text-muted">Software Packages</span>
              </div>
              <div className="reports-artifact-stat">
                <div className="reports-artifact-icon"><Library size={18} /></div>
                <h4>784</h4>
                <span className="reports-text-muted">Libraries</span>
              </div>
              <div className="reports-artifact-stat">
                <div className="reports-artifact-icon"><Shield size={18} /></div>
                <h4>612</h4>
                <span className="reports-text-muted">SBOM Verified</span>
              </div>
              <div className="reports-artifact-stat">
                <div className="reports-artifact-icon"><Network size={18} /></div>
                <h4>24</h4>
                <span className="reports-text-muted">CI/CD Integrations</span>
              </div>
            </div>
            <div className="reports-card-footer-link reports-left-align">
              <a href="#artifacts">View Artifact Reports &rarr;</a>
            </div>
          </div>

        </div>

      </div>
    </div>
    </div>
  );
};

export default ReportDashboard;